// import test from '../assets/test.png';

// import electroForklift from '../assets/forklifts/JAC/TitlePictures/electricForklift.png';
import petForklift from '../assets/forklifts/JAC/TitlePictures/petrolForklift.png';
import disForklift from '../assets/forklifts/JAC/TitlePictures/dieselForklift.png';
// import richtrakPhotos from '../assets/forklifts/JAC/TitlePictures/richtrakForklift.png';

// import CPD13 from '../assets/forklifts/JAC/Electric/cpd13.png';
// import CPD15 from '../assets/forklifts/JAC/Electric/cpd15.png';
// import CPD16 from '../assets/forklifts/JAC/Electric/cpd16.png';
// import CPD18 from '../assets/forklifts/JAC/Electric/cpd18.png';
// import CPD20 from '../assets/forklifts/JAC/Electric/cpd20.png';
// import CPD25 from '../assets/forklifts/JAC/Electric/cpd25.png';
// import CPD30 from '../assets/forklifts/JAC/Electric/cpd30.png';
// import CPD35 from '../assets/forklifts/JAC/Electric/cpd35.png';
// import CPD40 from '../assets/forklifts/JAC/Electric/cpd40.png';
// import CPD45 from '../assets/forklifts/JAC/Electric/cpd45.png';
// import CPD50 from '../assets/forklifts/JAC/Electric/cpd50.png';
// import CPD60 from '../assets/forklifts/JAC/Electric/cpd60.png';

// import CPQD10 from '../assets/forklifts/JAC/Petrol/CPQD10.png';
import CPQD15 from '../assets/forklifts/JAC/Petrol/CPQD15.png';
import CPQD18 from '../assets/forklifts/JAC/Petrol/CPQD18.png';
import CPQD20 from '../assets/forklifts/JAC/Petrol/CPQD20.png';
import CPQD25 from '../assets/forklifts/JAC/Petrol/CPQD25.png';
import CPQD30 from '../assets/forklifts/JAC/Petrol/CPQD30.png';
import CPQD35 from '../assets/forklifts/JAC/Petrol/CPQD35.png';
// import CPQD50 from '../assets/forklifts/JAC/Petrol/CPQD50.png';

// import CPCD10 from '../assets/forklifts/JAC/Diesel/cpcd10.png';
import CPCD15 from '../assets/forklifts/JAC/Diesel/cpcd15.png';
import CPCD18 from '../assets/forklifts/JAC/Diesel/cpcd18.png';
import CPCD20 from '../assets/forklifts/JAC/Diesel/cpcd20.png';
import CPCD25 from '../assets/forklifts/JAC/Diesel/cpcd25.png';
import CPCD30 from '../assets/forklifts/JAC/Diesel/cpcd30.png';
import CPCD35 from '../assets/forklifts/JAC/Diesel/cpcd35.png';
// import CPCD40 from '../assets/forklifts/JAC/Diesel/cpcd40.png';
// import CPCD45 from '../assets/forklifts/JAC/Diesel/cpcd45.png';
import CPCD50 from '../assets/forklifts/JAC/Diesel/cpcd50.png';
// import CPCD50m from '../assets/forklifts/JAC/Diesel/cpcd50m.png';
// import CPCD60 from '../assets/forklifts/JAC/Diesel/cpcd60.png';
import CPCD70 from '../assets/forklifts/JAC/Diesel/cpcd70.png';
// import CPCD80 from '../assets/forklifts/JAC/Diesel/cpcd80.png';
import CPCD100 from '../assets/forklifts/JAC/Diesel/cpcd100.png';
// import CPCD120 from '../assets/forklifts/JAC/Diesel/cpcd120.png';
// import CPCD135 from '../assets/forklifts/JAC/Diesel/cpcd135.png';
// import CPCD160 from '../assets/forklifts/JAC/Diesel/cpcd160.png';
// import CPCD180 from '../assets/forklifts/JAC/Diesel/cpcd180.png';

import electroForkliftGoodsense from '../assets/forklifts/Goodsense/electroForkliftGoodsense.png';
import disForkliftGoodsense from '../assets/forklifts/Goodsense/disForkliftGoodsense.png';
import FB15 from '../assets/forklifts/Goodsense/FB15.png';
import FB18Li from '../assets/forklifts/Goodsense/FB18Li.png';
// import FB18S from '../assets/forklifts/Goodsense/FB18S.png';
// import FB18 from '../assets/forklifts/Goodsense/FB18.png';
// import FB20Li from '../assets/forklifts/Goodsense/FB20Li.png';
// import FB20S from '../assets/forklifts/Goodsense/FB20S.png';
// import FB20 from '../assets/forklifts/Goodsense/FB20.png';
// import FB25 from '../assets/forklifts/Goodsense/FB25.png';
// import FB30H from '../assets/forklifts/Goodsense/FB30H.png';
import FB30 from '../assets/forklifts/Goodsense/FB30.png';
// import FB35 from '../assets/forklifts/Goodsense/FB35.png';
// import FB50 from '../assets/forklifts/Goodsense/FB50.png';

import FD15 from '../assets/forklifts/Goodsense/FD15.png';
import FD18 from '../assets/forklifts/Goodsense/FD18.png';
import FD20 from '../assets/forklifts/Goodsense/FD20.png';
import FD25 from '../assets/forklifts/Goodsense/FD25.png';
// import FD25S from '../assets/forklifts/Goodsense/FD25.png';
import FD30 from '../assets/forklifts/Goodsense/FD30.png';
// import FD30S from '../assets/forklifts/Goodsense/FD30S.png';
import FD35 from '../assets/forklifts/Goodsense/FD35.png';
// import FD35S from '../assets/forklifts/Goodsense/FD35S.png';
import FD50 from '../assets/forklifts/Goodsense/FD50.png';
import FD70 from '../assets/forklifts/Goodsense/FD70.png';
// import FD100 from '../assets/forklifts/Goodsense/FD100.png';

import shannForklifts from '../assets/forklifts/SHANN/shannForklifts.png';
import SHANN15 from '../assets/forklifts/SHANN/SHANN15.png';
import SHANN20 from '../assets/forklifts/SHANN/SHANN20.png';
import SHANN25 from '../assets/forklifts/SHANN/SHANN25.png';
import SHANN30 from '../assets/forklifts/SHANN/SHANN30.png';
import SHANN35 from '../assets/forklifts/SHANN/SHANN35.png';
import SHANN50 from '../assets/forklifts/SHANN/SHANN50.png';
// import SHANN70 from '../assets/forklifts/SHANN/SHANN70.png';
// import SHANN80 from '../assets/forklifts/SHANN/SHANN80.png';
// import SHANN100 from '../assets/forklifts/SHANN/SHANN100.png';

import electric_stab from '../assets/forklifts/SmallEquipment/electric_stab.png';
import trolley from '../assets/forklifts/SmallEquipment/trolley.png';
import electric_trolley from '../assets/forklifts/SmallEquipment/electric_trolley.png';

import frontMainXGMA from '../assets/forklifts/XGMA/frontal/frontMainXGMA.png';
import XG918H from '../assets/forklifts/XGMA/frontal/XG918H.png';
import XG931N from '../assets/forklifts/XGMA/frontal/XG931N.png';
import XG936N from '../assets/forklifts/XGMA/frontal/XG936N.png';
import XG955N from '../assets/forklifts/XGMA/frontal/XG955N.png';
import XG956N from '../assets/forklifts/XGMA/frontal/XG956N.png';
import XG958EV from '../assets/forklifts/XGMA/frontal/XG958EV.png';
import XG968N from '../assets/forklifts/XGMA/frontal/XG968N.png';

import gradingDraggersMainXGMA from '../assets/forklifts/XGMA/gradingDraggers/gradingDraggersMainXGMA.png';
import XG3165 from '../assets/forklifts/XGMA/gradingDraggers/XG3165.png';
import XG3180N from '../assets/forklifts/XGMA/gradingDraggers/XG3180N.png';
import XG3220 from '../assets/forklifts/XGMA/gradingDraggers/XG3220.png';

import excavatorLoadersMainXGMA from '../assets/forklifts/XGMA/excavatorLoaders/excavatorLoadersMainXGMA.png';
import XG765N from '../assets/forklifts/XGMA/excavatorLoaders/XG765N.png';
import XG765NEW from '../assets/forklifts/XGMA/excavatorLoaders/XG765NEW.png';
import XG7654TX from '../assets/forklifts/XGMA/excavatorLoaders/XG7654TX.png';
import XG765H4TX from '../assets/forklifts/XGMA/excavatorLoaders/XG765H4TX.png';

import rollersMainXGMA from '../assets/forklifts/XGMA/rollers/rollersMainXGMA.png';
import XG612H from '../assets/forklifts/XGMA/rollers/XG612H.png';
import XG614H from '../assets/forklifts/XGMA/rollers/XG614H.png';
import XG618H from '../assets/forklifts/XGMA/rollers/XG618H.png';
import XG620H from '../assets/forklifts/XGMA/rollers/XG620H.png';

import excavatorMainXGMA from '../assets/forklifts/XGMA/excavator/excavatorMainXGMA.png';
import XG822EL from '../assets/forklifts/XGMA/excavator/XG822EL.png';
import XG822FL from '../assets/forklifts/XGMA/excavator/XG822FL.png';
import XG825EL from '../assets/forklifts/XGMA/excavator/XG825EL.png';
import XG830F from '../assets/forklifts/XGMA/excavator/XG830F.png';
import XG836EL from '../assets/forklifts/XGMA/excavator/XG836EL.png';
import XG836FH from '../assets/forklifts/XGMA/excavator/XG836FH.png';
import XG836FHPRO from '../assets/forklifts/XGMA/excavator/XG836FHPRO.png';
import XG852FH from '../assets/forklifts/XGMA/excavator/XG852FH.png';
import XG8125WH from '../assets/forklifts/XGMA/excavator/XG8125WH.png';

import miniForkloftsMainXGMA from '../assets/forklifts/XGMA/miniForklifts/miniForkloftsMainXGMA.png';
import XG3080R from '../assets/forklifts/XGMA/miniForklifts/XG3080R.png';
import XG3120R from '../assets/forklifts/XGMA/miniForklifts/XG3120R.png';

import mainXGMA from '../assets/forklifts/XGMA/mainXGMA.png';

// import lonkingMain from '../assets/forklifts/Lonking/lonkingMain.png';

export const result = [
  // {
  //   url: 'lonking',
  //   title: 'Строительная техника Lonking',
  //   img: lonkingMain,
  //   elems: [
  //     {
  //       url: 'ekskavator-pogruzchiki-lonking',
  //       title: 'Экскаваторы-погрузчики Lonking',
  //       img: test,
  //       pages: [
  //         {
  //           title: 'Экскаватор-погрузчик Lonking 84C Carraro',
  //           img: test,
  //           description: {
  //             model: 'Lonking 84C Carraro',
  //           },
  //         },
  //         {
  //           title: 'Экскаватор-погрузчик Lonking 83C',
  //           img: test,
  //           description: {
  //             model: 'Lonking 83C',
  //           },
  //         },
  //         {
  //           title: 'Экскаватор-погрузчик Lonking 84C Carraro',
  //           img: test,
  //           description: {
  //             model: 'Lonking 84C Carraro',
  //           },
  //         },
  //       ],
  //     },
  //     {
  //       url: 'mini-pogruzchiki-lonking',
  //       title: 'Мини-погрузчики Lonking',
  //       img: test,
  //       pages: [
  //         {
  //           title: 'Мини-погрузчик Lonking CDM316V',
  //           img: test,
  //           description: {
  //             model: 'CDM316V',
  //           },
  //         },
  //         {
  //           title: 'Мини-погрузчик Lonking CDM307',
  //           img: test,
  //           description: {
  //             model: 'CDM307',
  //           },
  //         },
  //         {
  //           title: 'Мини-погрузчик Lonking CDM312M',
  //           img: test,
  //           description: {
  //             model: 'CDM312M',
  //           },
  //         },
  //         {
  //           title: 'Мини-погрузчик Lonking CDM315T',
  //           img: test,
  //           description: {
  //             model: 'CDM315T',
  //           },
  //         },
  //         {
  //           title: 'Мини-погрузчик Lonking CDM312',
  //           img: test,
  //           description: {
  //             model: 'CDM312',
  //           },
  //         },
  //         {
  //           title: 'Мини-погрузчик Lonking CDM308',
  //           img: test,
  //           description: {
  //             model: 'CDM308',
  //           },
  //         },
  //         {
  //           title: 'Мини-погрузчик Lonking CDM303',
  //           img: test,
  //           description: {
  //             model: 'CDM303',
  //           },
  //         },
  //         {
  //           title: 'Мини-погрузчик Lonking CDM311T',
  //           img: test,
  //           description: {
  //             model: 'CDM311T',
  //           },
  //         },
  //       ],
  //     },
  //     {
  //       url: 'front-pogruzchiki-lonking',
  //       title: 'Фронтальные погрузчики Lonking',
  //       img: test,
  //       pages: [
  //         {
  //           title: 'Фронтальный погрузчик Lonking CDM908A',
  //           img: '',
  //           description: {
  //             model: 'CDM908A',
  //           },
  //         },
  //         {
  //           title: 'Фронтальный погрузчик Lonking CDM932N',
  //           img: '',
  //           description: {
  //             model: 'CDM932N',
  //           },
  //         },
  //         {
  //           title: 'Фронтальный погрузчик Lonking CDM936N',
  //           img: '',
  //           description: {
  //             model: 'CDM936N',
  //           },
  //         },
  //         {
  //           title: 'Фронтальный погрузчик Lonking LG833B(N)',
  //           img: '',
  //           description: {
  //             model: 'LG833B(N)',
  //           },
  //         },
  //         {
  //           title: 'Фронтальный погрузчик Lonking CDM835',
  //           img: '',
  //           description: {
  //             model: 'CDM835',
  //           },
  //         },
  //         {
  //           title: 'Фронтальный погрузчик Lonking CDM853N(GN)',
  //           img: '',
  //           description: {
  //             model: 'CDM853N(GN)',
  //           },
  //         },
  //         {
  //           title: 'Фронтальный погрузчик Lonking CDM853G',
  //           img: '',
  //           description: {
  //             model: 'CDM853G',
  //           },
  //         },
  //         {
  //           title: 'Фронтальный погрузчик Lonking CDM856',
  //           img: '',
  //           description: {
  //             model: 'CDM856',
  //           },
  //         },
  //         {
  //           title: 'Фронтальный погрузчик Lonking LG855B',
  //           img: '',
  //           description: {
  //             model: 'LG855B',
  //           },
  //         },
  //         {
  //           title: 'Фронтальный погрузчик Lonking ZL50NC',
  //           img: '',
  //           description: {
  //             model: 'ZL50NC',
  //           },
  //         },
  //         {
  //           title: 'Фронтальный погрузчик Lonking ZL50NCS',
  //           img: '',
  //           description: {
  //             model: 'ZL50NCS',
  //           },
  //         },
  //         {
  //           title: 'Фронтальный погрузчик Lonking CDM860',
  //           img: '',
  //           description: {
  //             model: 'CDM860',
  //           },
  //         },
  //         {
  //           title: 'Фронтальный погрузчик Lonking LG863N',
  //           img: '',
  //           description: {
  //             model: 'LG863N',
  //           },
  //         },
  //         {
  //           title: 'Фронтальный погрузчик Lonking LG876N',
  //           img: '',
  //           description: {
  //             model: 'LG876N',
  //           },
  //         },
  //       ],
  //     },
  //     {
  //       url: 'teleskopicheskiye-pogruzchiki-lonking',
  //       title: 'Телескопические погрузчики Lonking',
  //       img: test,
  //       pages: [
  //         {
  //           title: 'Телескописечкий погрузчик Lonking LGT4207',
  //           img: '',
  //           description: {
  //             model: 'LGT4207',
  //           },
  //         },
  //       ],
  //     },
  //     {
  //       url: 'excavator-lonking',
  //       title: 'Экскаваторы Lonking',
  //       img: test,
  //       pages: [
  //         {
  //           title: '',
  //           img: '',
  //           description: {
  //             model: '',
  //           },
  //         },
  //       ],
  //     },
  //     {
  //       url: 'autopogruzchiki-lonking',
  //       title: 'Вилочные погрузчики Lonking',
  //       img: test,
  //       pages: [
  //         {
  //           title: '',
  //           img: '',
  //           description: {
  //             model: '',
  //           },
  //         },
  //       ],
  //     },
  //     {
  //       url: 'katki-lonking',
  //       title: 'Дорожные катки Lonking',
  //       img: test,
  //       pages: [
  //         {
  //           title: '',
  //           img: '',
  //           description: {
  //             model: '',
  //           },
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    url: 'XGMA',
    title: 'Строительная техника XGMA',
    img: mainXGMA,
    elems: [
      {
        url: 'frontalXGMA',
        title: 'Фронтальные погрузчики',
        img: frontMainXGMA,
        pages: [
          {
            title: 'Фронтальный погрузчик XGMA XG918H',
            img: XG918H,
            description: {
              model: 'XG918H',
              operatingWeight: '6110',
              loadCapacity: '1800',
              bucketVolume: '1.0',
              enginePower: '60(75.6)',
            },
          },
          {
            title: 'Фронтальный погрузчик XGMA XG931N',
            img: XG931N,
            description: {
              model: 'XG931N',
              operatingWeight: '10400',
              loadCapacity: '3100',
              bucketVolume: '2.0',
              enginePower: '92(125)',
            },
          },
          {
            title: 'Фронтальный погрузчик XGMA XG936N',
            img: XG936N,
            description: {
              model: 'XG936N',
              operatingWeight: '10800',
              loadCapacity: '3200',
              bucketVolume: '1.8',
              enginePower: '92(125)',
            },
          },
          {
            title: 'Фронтальный погрузчик XGMA XG955N',
            img: XG955N,
            description: {
              model: 'XG955N',
              operatingWeight: '17200',
              loadCapacity: '5200',
              bucketVolume: '3.1',
              enginePower: '92(125)',
            },
          },
          {
            title: 'Фронтальный погрузчик XGMA XG956N',
            img: XG956N,
            description: {
              model: 'XG956N',
              operatingWeight: '17600',
              loadCapacity: '5700',
              bucketVolume: '3.4',
              enginePower: '162(220)',
            },
          },
          {
            title: 'Фронтальный погрузчик XGMA XG958EV',
            img: XG958EV,
            description: {
              model: 'XG958EV',
              operatingWeight: '18500',
              loadCapacity: '5500',
              bucketVolume: '3.0',
              enginePower: '180(150)',
            },
          },
          {
            title: 'Фронтальный погрузчик XGMA XG968N',
            img: XG968N,
            description: {
              model: 'XG968N',
              operatingWeight: '22100',
              loadCapacity: '7000',
              bucketVolume: '4.5',
              enginePower: '191(260)',
            },
          },
        ],
      },
      {
        url: 'gradingDraggersXGMA',
        title: 'Автогрейдеры',
        img: gradingDraggersMainXGMA,
        pages: [
          {
            title: 'Автогрейдер XGMA XG3165',
            img: XG3165,
            description: {
              model: 'XG3165',
              operatingWeight: '16.5',
              enginePower: '132(180)',
              bladeWidth: '3660',
              bladeHeight: '610',
            },
          },
          {
            title: 'Автогрейдер XGMA XG3180N',
            img: XG3180N,
            description: {
              model: 'XG3180N',
              operatingWeight: '15.5',
              enginePower: '132(180)',
              bladeWidth: '3965',
              bladeHeight: '610',
            },
          },
          {
            title: 'Автогрейдер XGMA XG3220',
            img: XG3220,
            description: {
              model: 'XG3220',
              operatingWeight: '20.05',
              enginePower: '179(240)',
              bladeWidth: '4270',
              bladeHeight: '610',
            },
          },
        ],
      },
      {
        url: 'excavatorLoadersXGMA',
        title: 'Экскаваторы-погрузчики',
        img: excavatorLoadersMainXGMA,
        pages: [
          {
            title: 'Экскаватор-погрузчик XGMA XG765N',
            img: XG765N,
            description: {
              model: 'XG765N',
              operatingWeight: '9120',
              loadCapacity: '3000',
              loaderBucketCapacity: '1,0',
              loaderExcavatorCapacity: '0,3',
            },
          },
          {
            title: 'Экскаватор-погрузчик XGMA XG765N (Новая версия)',
            img: XG765NEW,
            description: {
              model: 'XG765N (Новая версия)',
              operatingWeight: '9120',
              loadCapacity: '3000',
              loaderBucketCapacity: '1,0',
              loaderExcavatorCapacity: '0,3',
            },
          },
          {
            title: 'Экскаватор-погрузчик XGMA XG765 4TX',
            img: XG7654TX,
            description: {
              model: 'XG765 4TX',
              enginePower: '74,5(101)',
              typeManagment: 'Джойстик',
              loaderBucketCapacity: '1,2',
              loaderExcavatorCapacity: '0,3',
            },
          },
          {
            title: 'Экскаватор-погрузчик XGMA XG765H 4TX',
            img: XG765H4TX,
            description: {
              model: 'XG765H 4TX',
              enginePower: '74,5(101)',
              typeManagment: 'Джойстик',
              loaderBucketCapacity: '1,0',
              loaderExcavatorCapacity: '0,3',
            },
          },
        ],
      },
      {
        url: 'rollersXGMA',
        title: 'Катки',
        img: rollersMainXGMA,
        pages: [
          {
            title: 'Грунтовый каток XGMA XG612H',
            img: XG612H,
            description: {
              model: 'XG612H',
              operatingWeight: '13300',
              rollerWeight: '6500',
              rollerDiameter: '1550',
            },
          },
          {
            title: 'Дорожный каток XGMA XG614H',
            img: XG614H,
            description: {
              model: 'XG614H',
              operatingWeight: '15200',
              rollerWeight: '8200',
              rollerDiameter: '1550',
            },
          },
          {
            title: 'Дорожный каток XGMA XG618H',
            img: XG618H,
            description: {
              model: 'XG618H',
              operatingWeight: '19300',
              rollerWeight: '10350',
              rollerDiameter: '1550',
            },
          },
          {
            title: 'Дорожный каток XGMA XG620H',
            img: XG620H,
            description: {
              model: 'XG620H',
              operatingWeight: '21200',
              rollerWeight: '11200',
              rollerDiameter: '1550',
            },
          },
        ],
      },
      {
        url: 'excavatorXGMA',
        title: 'Экскаваторы',
        img: excavatorMainXGMA,
        pages: [
          {
            title: 'Гусеничный экскаватор XGMA XG822EL (Габарит)',
            img: XG822EL,
            description: {
              model: 'XG822EL',
              operatingWeight2: '21500',
              bucketVolume: '1.0',
              diggingDepth: '6640',
            },
          },
          {
            title: 'Гусеничный экскаватор XGMA XG822FL',
            img: XG822FL,
            description: {
              model: 'XG822FL',
              operatingWeight2: '21500',
              bucketVolume: '1.1',
              diggingDepth: '6640',
            },
          },
          {
            title: 'Гусеничный экскаватор XGMA XG825EL',
            img: XG825EL,
            description: {
              model: 'XG825EL',
              operatingWeight2: '24000',
              bucketVolume: '1.2',
              diggingDepth: '6875',
            },
          },
          {
            title: 'Гусеничный экскаватор XGMA XG830F',
            img: XG830F,
            description: {
              model: 'XG830F',
              operatingWeight2: '33000',
              bucketVolume: '1.4',
              diggingDepth: '7370',
            },
          },
          {
            title: 'Гусеничный экскаватор XGMA XG836EL',
            img: XG836EL,
            description: {
              model: 'XG836EL',
              operatingWeight2: '35000',
              bucketVolume: '1.7',
              diggingDepth: '6890',
            },
          },
          {
            title: 'Гусеничный экскаватор XGMA XG836FH',
            img: XG836FH,
            description: {
              model: 'XG836FH',
              operatingWeight2: '35000',
              bucketVolume: '1.7',
              diggingDepth: '6980',
            },
          },
          {
            title: 'Гусеничный экскаватор XGMA XG836FH PRO',
            img: XG836FHPRO,
            description: {
              model: 'XG836FH PRO',
              operatingWeight2: '35000',
              bucketVolume: '1.7',
              diggingDepth: '6890',
            },
          },
          {
            title: 'Гусеничный экскаватор XGMA XG852FH',
            img: XG852FH,
            description: {
              model: 'XG852FH',
              operatingWeight2: '51500',
              bucketVolume: '2.8',
              diggingDepth: '6260',
            },
          },
          {
            title: 'Гусеничный экскаватор XGMA XG8125WH',
            img: XG8125WH,
            description: {
              model: 'XG8125WH',
              operatingWeight2: '9000',
              bucketVolume: '0.45',
              diggingDepth: '3800',
            },
          },
        ],
      },
      {
        url: 'miniForkloftsXGMA',
        title: 'Мини-погрузчики',
        img: miniForkloftsMainXGMA,
        pages: [
          {
            title: 'Мини-погрузчик XGMA XG3080R',
            img: XG3080R,
            description: {
              model: 'XG3080R',
              operatingWeight: '3100',
              loadCapacity: '800',
              bucketVolume: '0.45',
              liftingHeight: '2400 мм',
            },
          },
          {
            title: 'Мини-погрузчик XGMA XG3120R',
            img: XG3120R,
            description: {
              model: 'XG3120R',
              operatingWeight: '3930',
              loadCapacity: '1200',
              bucketVolume: '0,54',
              liftingHeight: '2390 мм',
            },
          },
        ],
      },
    ],
  },
  {
    url: 'goodsense_forklifts',
    title: 'Вилочные погрузчики Goodsense',
    img: disForkliftGoodsense,
    elems: [
      {
        url: 'dieselForkliftGoodsense',
        title: 'Дизельные погрузчики',
        img: disForkliftGoodsense,
        pages: [
          {
            title: 'Дизельный погрузчик GOODSENSE FD15',
            img: FD15,
            description: {
              model: 'FD15',
              loadCapacity: '1.5 тонны',
              engineType: 'Дизельный',
              liftingHeight: '3м/4.8м',
              wheelType: 'Пневматические',
            },
          },
          {
            title: 'Дизельный погрузчик GOODSENSE FD18',
            img: FD18,
            description: {
              model: 'FD18',
              loadCapacity: '1.8 тонны',
              engineType: 'Дизельный',
              liftingHeight: '3м/4.8м',
              wheelType: 'Пневматические',
            },
          },
          {
            title: 'Дизельный погрузчик GOODSENSE FD20',
            img: FD20,
            description: {
              model: 'FD20',
              loadCapacity: '2.0 тонны',
              engineType: 'Дизельный',
              liftingHeight: '3м/4.8м',
              wheelType: 'Пневматические',
            },
          },
          {
            title: 'Дизельный погрузчик GOODSENSE FD25',
            img: FD25,
            description: {
              model: 'FD25',
              loadCapacity: '2.5 тонны',
              engineType: 'Дизельный',
              liftingHeight: '3м/4.8м',
              wheelType: 'Пневматические',
            },
          },
          // {
          //   title: 'Дизельный погрузчик GOODSENSE FD25S',
          //   img: FD25S,
          //   description: {
          //     model: 'FD25S',
          //     loadCapacity: '2.5 тонны',
          //     engineType: 'Дизельный',
          //     liftingHeight: '3.0м',
          //     wheelType: 'Пневматические',
          //   },
          // },
          {
            title: 'Дизельный погрузчик GOODSENSE FD30',
            img: FD30,
            description: {
              model: 'FD30',
              loadCapacity: '3.0 тонны',
              engineType: 'Дизельный',
              liftingHeight: '3м/4.8м',
              wheelType: 'Пневматические',
            },
          },
          // {
          //   title: 'Дизельный погрузчик GOODSENSE FD30S',
          //   img: FD30S,
          //   description: {
          //     model: 'FD30S',
          //     loadCapacity: '3.0 тонны',
          //     engineType: 'Дизельный',
          //     liftingHeight: '3.0м',
          //     wheelType: 'Пневматические',
          //   },
          // },
          {
            title: 'Дизельный погрузчик GOODSENSE FD35',
            img: FD35,
            description: {
              model: 'FD35',
              loadCapacity: '3.5 тонны',
              engineType: 'Дизельный',
              liftingHeight: '3м/4.8м',
              wheelType: 'Пневматические',
            },
          },
          // {
          //   title: 'Дизельный погрузчик GOODSENSE FD35S',
          //   img: FD35S,
          //   description: {
          //     model: 'FD35S',
          //     loadCapacity: '3.5 тонны',
          //     engineType: 'Дизельный',
          //     liftingHeight: '3.0м',
          //     wheelType: 'Пневматические',
          //   },
          // },
          {
            title: 'Дизельный погрузчик GOODSENSE FD50',
            img: FD50,
            description: {
              model: 'FD50',
              loadCapacity: '5.0 тонн',
              engineType: 'Дизельный',
              liftingHeight: '3м/4.5м',
              wheelType: 'Пневматические',
            },
          },
          {
            title: 'Дизельный погрузчик GOODSENSE FD70',
            img: FD70,
            description: {
              model: 'FD70',
              loadCapacity: '7.0 тонн',
              engineType: 'Дизельный',
              liftingHeight: '3м/4.5м',
              wheelType: 'Пневматические',
            },
          },
          // {
          //   title: 'Дизельный погрузчик GOODSENSE FD100',
          //   img: FD100,
          //   description: {
          //     model: 'FD100',
          //     loadCapacity: '10.0 тонн',
          //     engineType: 'Дизельный',
          //     liftingHeight: '3м',
          //     wheelType: 'Пневматические',
          //   },
          // },
        ],
      },
      {
        url: 'electricForkliftGoodsense',
        title: 'Электропогрузчики',
        img: electroForkliftGoodsense,
        pages: [
          {
            title: 'Электрический погрузчик GOODSENSE FB15Li',
            img: FB15,
            description: {
              model: 'FB15Li',
              loadCapacity: '1.5 тонна',
              batteryCapacity: '400 А/ч',
              engineType: 'Электрический',
              liftingHeight: '3м / 4.8м',
              wheelType: 'Пневматические',
            },
          },
          {
            title: 'Электрический погрузчик GOODSENSE FB18Li',
            img: FB18Li,
            description: {
              model: 'FB18Li',
              loadCapacity: '1.8 тонн',
              batteryCapacity: '150 А/ч',
              engineType: 'Электрический',
              liftingHeight: '3м',
              wheelType: 'Пневматические',
            },
          },
          // {
          //   title: 'Электрический погрузчик GOODSENSE FB18S',
          //   img: FB18S,
          //   description: {
          //     model: 'FB18S',
          //     loadCapacity: '1.8 тонн',
          //     batteryCapacity: '490 А/ч',
          //     engineType: 'Электрический',
          //     liftingHeight: '4.8м',
          //     wheelType: 'Пневматические',
          //   },
          // },
          // {
          //   title: 'Электрический погрузчик GOODSENSE FB18',
          //   img: FB18,
          //   description: {
          //     model: 'FB18',
          //     loadCapacity: '1.8 тонн',
          //     batteryCapacity: '490 А/ч',
          //     engineType: 'Электрический',
          //     liftingHeight: '3м',
          //     wheelType: 'Пневматические',
          //   },
          // },
          // {
          //   title: 'Электрический погрузчик GOODSENSE FB20Li',
          //   img: FB20Li,
          //   description: {
          //     model: 'FB20Li',
          //     loadCapacity: '2.0 тонны',
          //     batteryCapacity: '150 А/ч',
          //     engineType: 'Электрический',
          //     liftingHeight: '3м',
          //     wheelType: 'Пневматические',
          //   },
          // },
          // {
          //   title: 'Электрический погрузчик GOODSENSE FB20S',
          //   img: FB20S,
          //   description: {
          //     model: 'FB20S',
          //     loadCapacity: '2.0 тонны',
          //     batteryCapacity: '560 А/ч',
          //     engineType: 'Электрический',
          //     liftingHeight: '3.0м',
          //     wheelType: 'Пневматические',
          //   },
          // },
          // {
          //   title: 'Электрический погрузчик GOODSENSE FB20',
          //   img: FB20,
          //   description: {
          //     model: 'FB20',
          //     loadCapacity: '2.0 тонны',
          //     batteryCapacity: '560 А/ч',
          //     engineType: 'Электрический',
          //     liftingHeight: '4.8м',
          //     wheelType: 'Пневматические',
          //   },
          // },
          // {
          //   title: 'Электрический погрузчик GOODSENSE FB25',
          //   img: FB25,
          //   description: {
          //     model: 'FB25',
          //     loadCapacity: '2.5 тонны',
          //     batteryCapacity: '630 А/ч',
          //     engineType: 'Электрический',
          //     liftingHeight: '3.0 / 4.8м',
          //     wheelType: 'Пневматические',
          //   },
          // },
          // {
          //   title: 'Электрический погрузчик GOODSENSE FB30H',
          //   img: FB30H,
          //   description: {
          //     model: 'FB30H',
          //     loadCapacity: '3.0 тонны',
          //     batteryCapacity: '500 А/ч',
          //     engineType: 'Электрический',
          //     liftingHeight: '3.0м',
          //     wheelType: 'Пневматические',
          //   },
          // },
          {
            title: 'Электрический погрузчик GOODSENSE FB30Li',
            img: FB30,
            description: {
              model: 'FB30Li',
              loadCapacity: '3.0 тонны',
              batteryCapacity: '500 А/ч',
              engineType: 'Электрический',
              liftingHeight: '4.5м / 3.0м',
              wheelType: 'Пневматические',
            },
          },
          // {
          //   title: 'Электрический погрузчик GOODSENSE FB35',
          //   img: FB35,
          //   description: {
          //     model: 'FB35',
          //     loadCapacity: '3.5 тонн',
          //     batteryCapacity: '550 А/ч',
          //     engineType: 'Электрический',
          //     liftingHeight: '3.0м',
          //     wheelType: 'Пневматические',
          //   },
          // },
          // {
          //   title: 'Электрический погрузчик GOODSENSE FB50',
          //   img: FB50,
          //   description: {
          //     model: 'FB50',
          //     loadCapacity: '5.0 тонн',
          //     batteryCapacity: '700 А/ч',
          //     engineType: 'Электрический',
          //     liftingHeight: '3.0м',
          //     wheelType: 'Пневматические',
          //   },
          // },
        ],
      },
    ],
  },
  {
    url: 'jac_forklifts',
    title: 'Вилочные погрузчики JAC',
    img: disForklift,
    elems: [
      {
        url: 'dieselForkliftJAC',
        title: 'Дизельные погрузчики',
        img: disForklift,
        pages: [
          // {
          //   title: 'Дизельный вилочный погрузчик JAC CPCD 10',
          //   img: CPCD10,
          //   description: {
          //     model: 'CPCD 10',
          //     loadCapacity: '1 тонна',
          //     engineType: 'Дизельный',
          //     liftingHeight: '3-8 м',
          //     wheelType: 'пневма/суперэластик',
          //   },
          // },
          {
            title: 'Дизельный вилочный погрузчик JAC CPCD 15',
            img: CPCD15,
            description: {
              model: 'CPCD 15',
              loadCapacity: '1,5 тонны',
              engineType: 'Дизельный',
              liftingHeight: '3-8 м',
              wheelType: 'пневма/суперэластик',
            },
          },
          {
            title: 'Дизельный вилочный погрузчик JAC CPCD 18',
            img: CPCD18,
            description: {
              model: 'CPCD 18',
              loadCapacity: '1,8 тонны',
              engineType: 'Дизельный',
              liftingHeight: '3-8 м',
              wheelType: 'пневма/суперэластик',
            },
          },
          {
            title: 'Дизельный вилочный погрузчик JAC CPCD 20',
            img: CPCD20,
            description: {
              model: 'CPCD 20',
              loadCapacity: '2 тонны',
              engineType: 'Дизельный',
              liftingHeight: '3-8 м',
              wheelType: 'пневма/суперэластик',
            },
          },
          {
            title: 'Дизельный вилочный погрузчик JAC CPCD 25',
            img: CPCD25,
            description: {
              model: 'CPCD 25',
              loadCapacity: '2,5 тонны',
              engineType: 'Дизельный',
              liftingHeight: '3-8 м',
              wheelType: 'пневма/суперэластик',
            },
          },
          {
            title: 'Дизельный вилочный погрузчик JAC CPCD 30',
            img: CPCD30,
            description: {
              model: 'CPCD 30',
              loadCapacity: '3 тонны',
              engineType: 'Дизельный',
              liftingHeight: '3-8 м',
              wheelType: 'пневма/суперэластик',
            },
          },
          {
            title: 'Дизельный вилочный погрузчик JAC CPCD 35',
            img: CPCD35,
            description: {
              model: 'CPCD 35',
              loadCapacity: '3,5 тонны',
              engineType: 'Дизельный',
              liftingHeight: '3-8 м',
              wheelType: 'пневма/суперэластик',
            },
          },
          // {
          //   title: 'Дизельный вилочный погрузчик JAC CPCD 40',
          //   img: CPCD40,
          //   description: {
          //     model: 'CPCD 40',
          //     loadCapacity: '4 тонны',
          //     engineType: 'Дизельный',
          //     liftingHeight: '3-8 м',
          //     wheelType: 'пневма/суперэластик',
          //   },
          // },
          // {
          //   title: 'Дизельный вилочный погрузчик JAC CPCD 45',
          //   img: CPCD45,
          //   description: {
          //     model: 'CPCD 45',
          //     loadCapacity: '4,5 тонны',
          //     engineType: 'Дизельный',
          //     liftingHeight: '3-8 м',
          //     wheelType: 'пневма/суперэластик',
          //   },
          // },
          {
            title: 'Дизельный вилочный погрузчик JAC CPCD 50',
            img: CPCD50,
            description: {
              model: 'CPCD 50',
              loadCapacity: '5 тонн',
              engineType: 'Дизельный',
              liftingHeight: '3-8 м',
              wheelType: 'пневма/суперэластик',
            },
          },
          // {
          //   title: 'Дизельный вилочный погрузчик JAC CPCD 50 mini',
          //   img: CPCD50m,
          //   description: {
          //     model: 'CPCD50 mini',
          //     loadCapacity: '5 тонн',
          //     engineType: 'Дизельный',
          //     liftingHeight: '3-8 м',
          //     wheelType: 'пневма/суперэластик',
          //   },
          // },
          // {
          //   title: 'Дизельный вилочный погрузчик JAC CPCD 60',
          //   img: CPCD60,
          //   description: {
          //     model: 'CPCD 60',
          //     loadCapacity: '6 тонн',
          //     engineType: 'Дизельный',
          //     liftingHeight: '3-8 м',
          //     wheelType: 'пневма/суперэластик',
          //   },
          // },
          {
            title: 'Дизельный вилочный погрузчик JAC CPCD 70',
            img: CPCD70,
            description: {
              model: 'CPCD 70',
              loadCapacity: '7 тонн',
              engineType: 'Дизельный',
              liftingHeight: '3-8 м',
              wheelType: 'пневма/суперэластик',
            },
          },
          // {
          //   title: 'Дизельный вилочный погрузчик JAC CPCD 80',
          //   img: CPCD80,
          //   description: {
          //     model: 'CPCD 80',
          //     loadCapacity: '8 тонн',
          //     engineType: 'Дизельный',
          //     liftingHeight: '3-8 м',
          //     wheelType: 'пневма/суперэластик',
          //   },
          // },
          {
            title: 'Дизельный вилочный погрузчик JAC CPCD 100',
            img: CPCD100,
            description: {
              model: 'CPCD 100',
              loadCapacity: '10 тонн',
              engineType: 'Дизельный',
              liftingHeight: '3-8 м',
              wheelType: 'пневма/суперэластик',
            },
          },
          // {
          //   title: 'Дизельный вилочный погрузчик JAC CPCD 120',
          //   img: CPCD120,
          //   description: {
          //     model: 'CPCD 120',
          //     loadCapacity: '12 тонн',
          //     engineType: 'Дизельный',
          //     liftingHeight: '3-8 м',
          //     wheelType: 'пневма/суперэластик',
          //   },
          // },
          // {
          //   title: 'Дизельный вилочный погрузчик JAC CPCD 135',
          //   img: CPCD135,
          //   description: {
          //     model: 'CPCD 135',
          //     loadCapacity: '13,5 тонн',
          //     engineType: 'Дизельный',
          //     liftingHeight: '3-8 м',
          //     wheelType: 'пневма/суперэластик',
          //   },
          // },
          // {
          //   title: 'Дизельный вилочный погрузчик JAC CPCD 160',
          //   img: CPCD160,
          //   description: {
          //     model: 'CPCD 160',
          //     loadCapacity: '16 тонн',
          //     engineType: 'Дизельный',
          //     liftingHeight: '3-8 м',
          //     wheelType: 'пневма/суперэластик',
          //   },
          // },
          // {
          //   title: 'Дизельный вилочный погрузчик JAC CPCD 180...420',
          //   img: CPCD180,
          //   description: {
          //     model: 'CPCD 180...420',
          //     loadCapacity: 'до 60 тонн',
          //     engineType: 'Дизельный',
          //     liftingHeight: '3-8 м',
          //     wheelType: 'пневма/суперэластик',
          //   },
          // },
        ],
      },
      {
        url: 'petrolForkliftJAC',
        title: 'Бензиновые погрузчики',
        img: petForklift,
        pages: [
          // {
          //   title: 'Бензиновый вилочный погрузчик JAC CPQD 10',
          //   img: CPQD10,
          //   description: {
          //     model: 'CPQD 10',
          //     loadCapacity: '1 тонна',
          //     engineType: 'Газ-бензин',
          //     liftingHeight: '3-8 м',
          //     wheelType: 'пневма/суперэластик',
          //   },
          // },
          {
            title: 'Бензиновый вилочный погрузчик JAC CPQD 15',
            img: CPQD15,
            description: {
              model: 'CPQD 15',
              loadCapacity: '1,5 тонны',
              engineType: 'Газ/бензин',
              liftingHeight: '3-8 м',
              wheelType: 'пневма/суперэластик',
            },
          },
          {
            title: 'Бензиновый вилочный погрузчик JAC CPQD 18',
            img: CPQD18,
            description: {
              model: 'CPQD 18',
              loadCapacity: '1,8 тонны',
              engineType: 'Газ/бензин',
              liftingHeight: '3-8 м',
              wheelType: 'пневма/суперэластик',
            },
          },
          {
            title: 'Бензиновый вилочный погрузчик JAC CPQD 20',
            img: CPQD20,
            description: {
              model: 'CPQD 20',
              loadCapacity: '2 тонны',
              engineType: 'Газ/бензин',
              liftingHeight: '3-8 м',
              wheelType: 'пневма/суперэластик',
            },
          },
          {
            title: 'Бензиновый вилочный погрузчик JAC CPQD 25',
            img: CPQD25,
            description: {
              model: 'CPQD 25',
              loadCapacity: '2,5 тонны',
              engineType: 'Газ/бензин',
              liftingHeight: '3-8 м',
              wheelType: 'пневма/суперэластик',
            },
          },
          {
            title: 'Бензиновый вилочный погрузчик JAC CPQD 30',
            img: CPQD30,
            description: {
              model: 'CPQD 30',
              loadCapacity: '3 тонны',
              engineType: 'Газ/бензин',
              liftingHeight: '3-8 м',
              wheelType: 'пневма/суперэластик',
            },
          },
          {
            title: 'Бензиновый вилочный погрузчик JAC CPQD 35',
            img: CPQD35,
            description: {
              model: 'CPQD 35',
              loadCapacity: '3,5 тонны',
              engineType: 'Газ/бензин',
              liftingHeight: '3-8 м',
              wheelType: 'пневма/суперэластик',
            },
          },
          // {
          //   title: 'Бензиновый вилочный погрузчик JAC CPQD 50 mini',
          //   img: CPQD50,
          //   description: {
          //     model: 'CPQD50 mini',
          //     loadCapacity: '5 тонн',
          //     engineType: 'Газ-бензин',
          //     liftingHeight: '3-8 м',
          //     wheelType: 'пневма/суперэластик',
          //   },
          // },
        ],
      },
      // {
      //   url: 'electricForkliftJAC',
      //   title: 'Электропогрузчики',
      //   img: electroForklift,
      //   pages: [
      //     {
      //       title: 'Электрический вилочный погрузчик JAC CPD 13',
      //       img: CPD13,
      //       description: {
      //         model: 'CPD 13',
      //         loadCapacity: '1.3 тонны',
      //         engineType: 'Электрический',
      //         liftingHeight: '3-8 м',
      //         wheelType: 'пневма/суперэластик',
      //       },
      //     },
      //     {
      //       title: 'Электрический вилочный погрузчик JAC CPD 15',
      //       img: CPD15,
      //       description: {
      //         model: 'CPD 15',
      //         loadCapacity: '1.5 тонны',
      //         engineType: 'Электрический',
      //         liftingHeight: '3-8 м',
      //         wheelType: 'пневма/суперэластик',
      //       },
      //     },
      //     {
      //       title: 'Электрический вилочный погрузчик JAC CPD 16',
      //       img: CPD16,
      //       description: {
      //         model: 'CPD 16',
      //         loadCapacity: '1.6 тонны',
      //         engineType: 'Электрический',
      //         liftingHeight: '3-8 м',
      //         wheelType: 'пневма/суперэластик',
      //       },
      //     },
      //     {
      //       title: 'Электрический вилочный погрузчик JAC CPD 18',
      //       img: CPD18,
      //       description: {
      //         model: 'CPD 18',
      //         loadCapacity: '1.8 тонны',
      //         engineType: 'Электрический',
      //         liftingHeight: '3-8 м',
      //         wheelType: 'пневма/суперэластик',
      //       },
      //     },
      //     {
      //       title: 'Электрический вилочный погрузчик JAC CPD 20',
      //       img: CPD20,
      //       description: {
      //         model: 'CPD 20',
      //         loadCapacity: '2 тонны',
      //         engineType: 'Электрический',
      //         liftingHeight: '3-8 м',
      //         wheelType: 'пневма/суперэластик',
      //       },
      //     },
      //     {
      //       title: 'Электрический вилочный погрузчик JAC CPD 25',
      //       img: CPD25,
      //       description: {
      //         model: 'CPD 25',
      //         loadCapacity: '2,5 тонны',
      //         engineType: 'Электрический',
      //         liftingHeight: '3-8 м',
      //         wheelType: 'пневма/суперэластик',
      //       },
      //     },
      //     {
      //       title: 'Электрический вилочный погрузчик JAC CPD 30 GT',
      //       img: CPD30,
      //       description: {
      //         model: 'CPD 30',
      //         loadCapacity: '3 тонны',
      //         engineType: 'Электрический',
      //         liftingHeight: '3-8 м',
      //         wheelType: 'пневма/суперэластик',
      //       },
      //     },
      //     {
      //       title: 'Электрический вилочный погрузчик JAC CPD 35',
      //       img: CPD35,
      //       description: {
      //         model: 'CPD 35',
      //         loadCapacity: '3,5 тонны',
      //         engineType: 'Электрический',
      //         liftingHeight: '3-8 м',
      //         wheelType: 'пневма/суперэластик',
      //       },
      //     },
      //     {
      //       title: 'Электрический вилочный погрузчик JAC CPD 40',
      //       img: CPD40,
      //       description: {
      //         model: 'CPD 40',
      //         loadCapacity: '4 тонны',
      //         engineType: 'Электрический',
      //         liftingHeight: '3-6 м',
      //         wheelType: 'пневма/суперэластик',
      //       },
      //     },
      //     {
      //       title: 'Электрический вилочный погрузчик JAC CPD 45',
      //       img: CPD45,
      //       description: {
      //         model: 'CPD 45',
      //         loadCapacity: '4,5 тонны',
      //         engineType: 'Электрический',
      //         liftingHeight: '3-6 м',
      //         wheelType: 'пневма/суперэластик',
      //       },
      //     },
      //     {
      //       title: 'Электрический вилочный погрузчик JAC CPD 50',
      //       img: CPD50,
      //       description: {
      //         model: 'CPD 50',
      //         loadCapacity: '5 тонн',
      //         engineType: 'Электрический',
      //         liftingHeight: '3-8 м',
      //         wheelType: 'пневма/суперэластик',
      //       },
      //     },
      //     {
      //       title: 'Электрический вилочный погрузчик JAC CPD 60',
      //       img: CPD60,
      //       description: {
      //         model: 'CPD 60',
      //         loadCapacity: '6 тонн',
      //         engineType: 'Электрический',
      //         liftingHeight: '3-8 м',
      //         wheelType: 'пневма/суперэластик',
      //       },
      //     },
      //   ],
      // },
    ],
  },
  {
    url: 'shann_forklifts',
    title: 'Вилочные погрузчики SHANN',
    img: shannForklifts,
    elems: [
      {
        url: 'electricForkliftShann',
        title: 'Электропогрузчики',
        img: shannForklifts,
        pages: [
          {
            title: 'Электрический погрузчик SHANN 15',
            img: SHANN15,
            description: {
              model: 'SHANN 15',
              loadCapacity: '1.5 тонны',
              batteryCapacity: '500 А/ч (LiFePO12)',
              engineType: 'Электрический',
              liftingHeight: '3м',
              wheelType: 'Пневматические',
            },
          },
          {
            title: 'Электрический погрузчик SHANN 20',
            img: SHANN20,
            description: {
              model: 'SHANN 20',
              loadCapacity: '2.0 тонны',
              batteryCapacity: '100-125 А/ч (LiFePO4)',
              engineType: 'Электрический',
              liftingHeight: '3м',
              wheelType: 'Пневматические',
            },
          },
          {
            title: 'Электрический погрузчик SHANN 25',
            img: SHANN25,
            description: {
              model: 'SHANN 25',
              loadCapacity: '2.5 тонны',
              batteryCapacity: '100-125 А/ч (LiFePO5)',
              engineType: 'Электрический',
              liftingHeight: '3м',
              wheelType: 'Пневматические',
            },
          },
          {
            title: 'Электрический погрузчик SHANN 30',
            img: SHANN30,
            description: {
              model: 'SHANN 30',
              loadCapacity: '3.0 тонны',
              batteryCapacity: '230 А/ч (LiFePO6)',
              engineType: 'Электрический',
              liftingHeight: '3м',
              wheelType: 'Пневматические',
            },
          },
          {
            title: 'Электрический погрузчик SHANN 35',
            img: SHANN35,
            description: {
              model: 'SHANN 35',
              loadCapacity: '3.5 тонны',
              batteryCapacity: '230 А/ч (LiFePO6)',
              engineType: 'Электрический',
              liftingHeight: '3м',
              wheelType: 'Пневматические',
            },
          },
          {
            title: 'Электрический погрузчик SHANN 50',
            img: SHANN50,
            description: {
              model: 'SHANN 50',
              loadCapacity: '5.0 тонн',
              batteryCapacity: '130-280 А/ч (LiFePO8)',
              engineType: 'Электрический',
              liftingHeight: '3м',
              wheelType: 'Пневматические',
            },
          },
          // {
          //   title: 'Электрический погрузчик SHANN 70',
          //   img: SHANN70,
          //   description: {
          //     model: 'SHANN 70',
          //     loadCapacity: '7.0 тонн',
          //     batteryCapacity: '230 А/ч (LiFePO9)',
          //     engineType: 'Электрический',
          //     liftingHeight: '3м',
          //     wheelType: 'Пневматические',
          //   },
          // },
          // {
          //   title: 'Электрический погрузчик SHANN 80',
          //   img: SHANN80,
          //   description: {
          //     model: 'SHANN 80',
          //     loadCapacity: '8.0 тонн',
          //     batteryCapacity: '230 А/ч (LiFePO10)',
          //     engineType: 'Электрический',
          //     liftingHeight: '3м',
          //     wheelType: 'Пневматические',
          //   },
          // },
          // {
          //   title: 'Электрический погрузчик SHANN 100',
          //   img: SHANN100,
          //   description: {
          //     model: 'SHANN 100',
          //     loadCapacity: '10.0 тонн',
          //     batteryCapacity: '230 А/ч (LiFePO11)',
          //     engineType: 'Электрический',
          //     liftingHeight: '3м',
          //     wheelType: 'Пневматические',
          //   },
          // },
        ],
      },
    ],
  },
  {
    url: 'small_equipment',
    title: 'Малая складская техника',
    img: electric_stab,
    elems: [
      {
        url: 'trolleys',
        title: 'Ручные тележки',
        img: trolley,
        pages: [
          {
            title: 'Ручные тележки',
            img: trolley,
            description: {
              loadCapacity: '1-3 т.',
              liftingHeight: '',
              longType: '1.15-2 м.',
              model: '',
              batteryCapacity: '',
              engineType: '',
              wheelType: '',
            },
          },
        ],
      },
      {
        url: 'electric_trolley',
        title: 'Самоходный перевозчик палетов',
        img: electric_trolley,
        pages: [
          {
            title: 'Самоходный перевозчик палетов',
            img: electric_trolley,
            description: {
              loadCapacity: '1-3 т.',
              liftingHeight: '',
              longType: '1.15-2 м.',
              model: '',
              batteryCapacity: '',
              engineType: '',
              wheelType: '',
            },
          },
        ],
      },
      {
        url: 'electric_stab',
        title: 'Штабелеры',
        img: electric_stab,
        pages: [
          {
            title: 'Штабелеры',
            img: electric_stab,
            description: {
              model: '',
              batteryCapacity: '',
              engineType: '',
              wheelType: '',
              loadCapacity: '1-3 т.',
              liftingHeight: '3-6 м.',
              longType: '1.15-2 м.',
            },
          },
        ],
      },
    ],
  },
];
